import { render, staticRenderFns } from "./2faSMS.vue?vue&type=template&id=a651338e&scoped=true&"
import script from "./2faSMS.vue?vue&type=script&lang=js&"
export * from "./2faSMS.vue?vue&type=script&lang=js&"
import style0 from "./2faSMS.vue?vue&type=style&index=0&id=a651338e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a651338e",
  null
  
)

export default component.exports